export default __webpack_public_path__ + "static/media/proof-of-concept.cee3b4dc.gif";